<se-fe-page
  [seFeDataLoaded]="true"
  class="commerce-shell se-product-management"
  id="se-product-management"
  seFeDataWidth="full">
  <se-fe-header seFePageHeader seFeDataTitle="Commerce" size="750"></se-fe-header>

  <se-fe-tabs
    seFePageTabs
    [seFeDataTabs]="tabs()"
    [seFeDataTabPanel]="tabPanel"
    seFeDataAriaLabel="Commerce navigation"></se-fe-tabs>

  <se-fe-tab-panel #tabPanel class="commerce-shell__content" seFePageContent>
    <router-outlet></router-outlet>
  </se-fe-tab-panel>
</se-fe-page>
